import styled from 'styled-components';
import { ApButtonTab, colors } from '@alixpartners/ui-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 32px;
  background-color: ${colors.white};
  height: 59px;
  align-items: center;
  border-bottom: 1px solid ${colors.grey3};
  box-sizing: border-box;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Note = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: ${colors.green600};
  margin-right: 16px;

  @media (max-width: 1120px) {
    display: none;
  }
`;

interface ISelectedState {
  isSelected: boolean;
}

export const ButtonTab = styled(ApButtonTab)<ISelectedState>`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
  font-size: 16px;
  line-height: 20px;
  color: ${({ isSelected }) => (isSelected ? colors.grey7 : colors.grey5)};
  width: 170px;
  transition: none;
`;
